<script setup>
    const hideInfo = ref(true);
    const modelValue = defineModel()
</script>
<template>
    
    <div 
        style="word-wrap: break-word;"
        class="py-3 font-light w-full text-base md:text-[20px] md:leading-[26px] "
        v-if="modelValue.desc_0"
        v-html="modelValue.desc_0" 
    ></div>

    <div 
        style="word-wrap: break-word;"
        class="py-3 w-full text-base md:text-[20px] font-light md:leading-[26px] "
        :class="hideInfo && 'max-[768px]:hidden'"
        v-if="modelValue.desc_1"
        v-html="modelValue.desc_1" 
    ></div>
    
    <p class="text-brand-blue font-medium cursor-pointer block md:hidden"
        @click="hideInfo = !hideInfo">
        {{ hideInfo ? "Подробнее" : "Скрыть" }}
    </p>

</template>